import {
    UTILITIES_TIMEZONES_GET,
    UTILITIES_REPORT_COLUMNS_GET,
    UTILITIES_REPORT_COLUMNS_GET_LOADING,
    UTILITIES_TUNE_ADVERTISERS_BY_AGENT_GET,
    UTILITIES_TUNE_PUBLISHER_BY_AGENT_GET,
} from '../actions/types';

import {
    AJAX_NOT_RUNNING,
} from '../services/config';

const initialState = {
    timezonesList: [],
    reportColumns: [],
    reportColumnsLoading: AJAX_NOT_RUNNING,
    advertiserListByAgent: [],
    publisherListByAgent: [],
};

export default function (state = initialState, action) {

    switch (action.type) {
        case UTILITIES_TUNE_ADVERTISERS_BY_AGENT_GET:
            return {
                ...state,
                advertiserListByAgent: action.payload,
            }
        case UTILITIES_TUNE_PUBLISHER_BY_AGENT_GET:
            return {
                ...state,
                publisherListByAgent: action.payload,
            }
        case UTILITIES_TIMEZONES_GET:

            return {
                ...state,
                timezonesList: action.payload,
            }
        case UTILITIES_REPORT_COLUMNS_GET:
            return {
                ...state,
                reportColumns: action.payload,
            }
        case UTILITIES_REPORT_COLUMNS_GET_LOADING:
            return {
                ...state,
                reportColumnsLoading: action.payload,
            }
        default:
            return state;
    }

}